import { FC } from "react";

type Props = {
  size?: number;
};

const NoNotificationsImage: FC<Props> = ({ size = 200 }) => {
  return (
    <div style={{ width: size }}>
      <svg viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
        <g transform="matrix(3,0,0,3,0,0)">
          <path
            d="M160.241,103.289c-2.9-12.614-8.382-22.1-21.4-25.914-10.969-3.213-36.388-2.192-51.042-1.323-.883.052-.748,1.1.112,1.091,12.8-.134,34.586-2.09,49.061,1.241,14.661,3.375,20.3,15.418,22.616,29.533,1.432,8.725,1.028,17.629.038,26.384-.12,1.062,1.2,1.2,1.316.127C162.089,124.118,162.556,113.374,160.241,103.289Z"
            fill="#191919"
          ></path>
          <path
            d="M74.157,42.161c9.1,4.172,21.457,2.8,29.263-1.645-.2,7.387-3.462,15.409-9.72,19.626-9.719,6.549-27.864,1.726-28.717-11.731-.059-.927-1.15-.987-1.189-.052-.573,13.7,18.248,19.8,29.159,14.2,7.637-3.917,11.894-13.5,12.156-21.861.085-2.684-1.084-2.356-2.953-1.4-10.349,5.3-20.986,3.82-27.543,1.749A.606.606,0,0,0,74.157,42.161Z"
            fill="#191919"
          ></path>
          <path
            d="M56.534,38.9C53.7,34.678,58.09,27.58,64.183,27.948c5.428.327,9.153,6.472,6.729,11.372a8.369,8.369,0,0,1-6.968,4.665c-1.107.067-.92,1.767.179,1.712,6.648-.334,11.312-7.82,8.224-13.832A9.49,9.49,0,0,0,56.7,29.548c-2.475,2.587-3.729,7.154-1.2,10.115A.643.643,0,0,0,56.534,38.9Z"
            fill="#191919"
          ></path>
          <path
            d="M60.332,36.912c1.9,1.907,3.963-.224,2.124-1.809C61.132,33.685,58.28,34.852,60.332,36.912Z"
            fill="#191919"
          ></path>
          <path
            d="M66.239,104.051c-.076-1.151-1.5-1.5-2.094.127C62.967,107.391,66.408,106.6,66.239,104.051Z"
            fill="#191919"
          ></path>
          <path
            d="M87.248,102.107c1.14,1.316,3.738-1.308,2.557-2.34S86.4,101.131,87.248,102.107Z"
            fill="#191919"
          ></path>
          <path
            d="M85.678,75.244c.464-.983-.105-7.932-.352-8.889a.748.748,0,0,0-1.443.231c0,1,.15,8.03.472,8.7A.748.748,0,0,0,85.678,75.244Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M80,74.713c-.106-1.308-.466-8.223-.883-9.166-.247-.56-1.035-.3-1.2.172-.328.962.226,8.291.479,9.57C78.546,76.052,80.122,76.276,80,74.713Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M150.911,43.162c-8.12-8.313-18.619,2.8-20.823,11.29-1.391,5.36-.081,7.364,3.223,7.477,19.367.658,39.9-.26,59.244-1.212,1.061-.052,1.173-1.522.112-1.495-6.87.172-49.7,1.717-59.162,1.024-2.355-.172-2.67-1.636-2.183-4.134C132.837,48.34,143.943,36,150.484,45.2c.529.743,1.316.239,1.623-.434,9.428-20.7,41.648-25.126,41.308,10.923a.748.748,0,1,0,1.5,0C196.959,22.079,164.72,18.355,150.911,43.162Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M26.688,74.227C18.068,60.77,3.828,71.556,5.073,84.59c.072.748,1.389.748,1.406,0,.314-13.8,12.593-20.693,19.11-8.957.651,1.173,1.584,1.226,1.989.314,4.036-9.095,18.254-.5,18.287,9.024,0,1.264.292,1.012-1.846,1.077-11.417.344-26.319.164-36.247,0a.673.673,0,0,0-.037,1.346c9.5.2,23.753.737,34.22.329,3.342-.131,5.979.628,5.608-2.894C46.412,73.937,32.333,64.665,26.688,74.227Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M57.028,40.583c-.889.362-9.154,6.214-8.224,6.9.571.422,9.33-3.679,9.794-3.469s-.232,10.34.748,10.093,2.859-8.644,2.99-9.383C63.088,40.5,59.835,39.44,57.028,40.583Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M60.609,103.1c-.262-.217-5.332-3.329-5.234-2.938.281,1.116,3.739,4.373,3.739,4.77s-5.376,1.943-5.054,2.153a44.425,44.425,0,0,0,6.168-.067C62.121,106.678,61.968,104.225,60.609,103.1Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M83.592,91.423c-.434.311.426,6.692-.067,6.946s-5.174-1.5-5.383-1.316,3.524,2.981,4.672,3.29c1.806.486,3.54-.456,3.327-2.542C86.08,97.2,84,91.129,83.592,91.423Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M141.079,107.461a122.229,122.229,0,0,0-26.168,1.2c-2.355.358-1.5,3.911.994,3.739a231.665,231.665,0,0,1,25.5-.748C143.441,111.719,144.071,107.653,141.079,107.461Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M115.741,141.165c-.072,9.353.214,21.827.478,31.588a.831.831,0,1,0,1.66-.082c.075-8.718-.509-22.43-.583-31.588C117.288,140.021,115.749,140.141,115.741,141.165Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M104.534,141.92c.081,2.5.668,24.792,1.061,30.175.143,1.959,1.6,2.056,1.563,0-.136-7.1-1.093-27.663-1.286-30.4C105.807,140.768,104.506,141.068,104.534,141.92Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M133.46,113.315c.142,1.667.277,18.018.277,19.222s2.908-4.815,3.335-6.378,2.549,6.52,3.042,6.236.845-17.548.853-19.125A55.972,55.972,0,0,0,133.46,113.315Z"
            fill="#37a1ff"
          ></path>
          <path
            d="M157.961,135.692c-16.6,1.068-34.429,1.69-51.775,2.243a208.468,208.468,0,0,0-2.49-27.559c-1.272-8.217-2.352-17.337-7.162-24.41-4.063-5.975-11.214-10.239-18.527-8.374-10.668,2.72-16.187,14.534-17.944,24.672,2.849-4.7,11.866-.844,10.819,4.935a18.982,18.982,0,0,1,14.489,12.187c-4.972-1.69-14.287-2.43-16.762-1.5-.957-1.375-1.338-4.127-1.323-6.183-3.253.688-7.163-.62-7.9-4.134a77.7,77.7,0,0,0-.2,12.022,43.737,43.737,0,0,0-8.284,1.316c-1.494.385-4.142,1.361-1.159,2.781a23.955,23.955,0,0,0,4.023,1.159c-7.973,4.282-13.811,12.327-7.283,10.43a62.335,62.335,0,0,1,8.868-1.914c-2.243,2.041-5.642,6.057-6.856,8.807-2.312,5.236.7,4.531,4.7,3.043l14.4-5.368a27.649,27.649,0,0,0-1.719,5.428c-.592,2.926,1.5,2.73,3.319,1.121,2.11-1.867,8.636-7.058,11.17-7.955a27.535,27.535,0,0,0-2.086,9.847.748.748,0,0,0,1.2.635,73.043,73.043,0,0,1,11.963-8.777,52.686,52.686,0,0,0,4.8,6.916c2.588,3.152,3.738.329,5.084-2.094a36.626,36.626,0,0,0,1.944-5.158c.441-1.2-.859-1.278-1.129-.524a34.627,34.627,0,0,1-2.991,6.258c-.748,1.234-.947,1.26-2.4-.381-4.557-5.148-3.868-7.482-6.5-5.959a66.631,66.631,0,0,0-10.378,7.424,25.953,25.953,0,0,1,1.57-6.9c.938-2.525,1.182-3.947-2.123-2.437s-9.069,5.981-11.963,8.725a25.025,25.025,0,0,1,1.8-5.914c.622-1.781-.621-2.242-2.183-1.66-4.254,1.586-13.458,5.7-17.548,6.251.411-3.514,4.961-8.146,7.828-11.088.941-.966,1.7-2.457-.434-2.123a106.112,106.112,0,0,0-11.326,2.445c1.5-3.051,7.623-6.849,10.4-8.688.36-.238.7-.836-.112-1.174-1.579-.662-3.274-1.032-4.912-1.548,14.729-4.067,20.07,1.3,19.439-1.674-.09-.426-1.585-1.824,1.727-1.772,2.886.045,14.486,1.557,16.142,2.587.562.349,1.1-.427.793-.913s-1.66-1.645-.651-1.816c3.529-.6,12.1,1.57,15.222,3.072a153.828,153.828,0,0,1,.972,16.367c.005,1.181.905,1.111,1.772,1.106,13.458-.084,36.976-1.307,51.827-2.482C159.083,136.915,159.023,135.624,157.961,135.692ZM87.54,117.33c-.957-1.982-1.249-6.931-.965-9.481-2.845-.478-6.394-3.842-4.238-7.7-1.462-.715-4.381-2.938-4.2-3.1.209-.179,4.889,1.57,5.383,1.316s-.367-6.635.067-6.946c.347-.248,1.876,4.026,2.385,5.735,3.426-.909,9.034.2,7.641,7.312,2.482,1,6.729,4.037,8.224,6.093a41.359,41.359,0,0,1,1.4,9.675A34.222,34.222,0,0,0,87.54,117.33Z"
            fill="#191919"
          ></path>
        </g>
      </svg>
    </div>
  );
};

export default NoNotificationsImage;
